const MetiFilesIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2141_25615)" />
      <path
        d="M46.8381 25.1229H41.3381V19.6229L46.8381 25.1229ZM47.5335 27.5884V51.8643H22.6255V22.5941C22.6255 21.5826 23.0048 20.6344 23.7002 19.939C24.3956 19.2436 25.3439 18.8643 26.3554 18.8643H38.8094V27.5884H47.5335Z"
        fill="white"
      />
      <path
        d="M31.2233 39.0311L30.3382 40.6115H29.4532L28.5681 39.0311V41.4966H27.4302V37.0713H28.6313L29.8957 39.4104L31.1601 37.0713H32.3612V41.4966H31.2233V39.0311Z"
        fill="#EF4E75"
      />
      <path
        d="M36.2807 41.4966H32.8037V37.0713H36.2807V37.9563H33.8784V38.7782H35.775V39.6632H33.8784V40.5483H36.2807V41.4966Z"
        fill="#EF4E75"
      />
      <path
        d="M39.1257 41.4966H37.9877V37.9563H36.6602V37.0713H40.4533V37.9563H39.1257V41.4966Z"
        fill="#EF4E75"
      />
      <path
        d="M43.1084 41.4966H40.8325V40.6115H41.4015V37.9563H40.8325V37.0713H43.1084V37.9563H42.5394V40.6115H43.1084V41.4966Z"
        fill="#EF4E75"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2141_25615"
          x1="8"
          y1="9.84619"
          x2="57"
          y2="63.8462"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE7999" />
          <stop offset="1" stop-color="#ED4971" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default MetiFilesIconSubcategory
